import { render, staticRenderFns } from "./StaticCopyIcon.vue?vue&type=template&id=1f9b0639&scoped=true"
import script from "./StaticCopyIcon.vue?vue&type=script&lang=js"
export * from "./StaticCopyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b0639",
  null
  
)

export default component.exports